'use client';

import React from 'react';

import { useParams, useSearchParams } from 'next/navigation';

import { BrowseProductsList } from '../../components/BrowseProductsList';
import { Header } from '../../components/Header';

import { Breadcrumbs } from '@/components/Breadcrumbs';
import { Filters } from '@/components/Filters';
import { BrowseByTypes } from '@/modules/activityTracker/constants';
import { useBrandPageBySlug } from '@/modules/brands/hooks/useBrandPageBySlug';
import { useBrandBreadcrumbs } from '@/modules/breadcrumbs/useBrandBreadcrumbs';
import { useBreadcrumbTrackingOnClick } from '@/modules/browse/hooks';
import { useBrowseTracking } from '@/modules/browse/useBrowseTracking';
import { useSearchId } from '@/modules/search/useSearchId';

export function Brand() {
  const slug = useParams().slug as string;
  const params = useSearchParams();
  const { data } = useBrandPageBySlug(slug);
  const searchId = useSearchId();
  const brand = data?.data;
  const { handleProductClick } = useBrowseTracking({
    searchId,
    browseType: BrowseByTypes.BRAND,
    label: brand?.name || '',
  });
  const breadcrumbItems = useBrandBreadcrumbs(brand);
  const onBreadcrumbClick = useBreadcrumbTrackingOnClick();

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        onBreadcrumbClick={onBreadcrumbClick}
      />
      <Header title={brand?.name || ''} description={brand?.copy} />
      <Filters />
      <BrowseProductsList
        handleProductClick={handleProductClick}
        query={params.get('q') || ''}
      />
    </>
  );
}
